module.exports = __webpack_public_path__ + "static/media/Rotated tooth4.16e27664.png";